import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { AvailableInventorySectionResponse } from '~client/model/available-inventory-section-response';

/* User APIs pertaining to available inventory for promoters/guest list usage */
export class ClientInventoryAvailabilityController extends BaseController {
  public getAvailableSections$(eventId: number): Observable<AvailableInventorySectionResponse> {
    return this.get$('/client/availableInventory/section', { eventId });
  }

  public getAvailableInventory$(
    eventId: number,
    sectionCode: number,
  ): Observable<AvailableInventorySectionResponse> {
    return this.get$('/client/availableInventory/inventory', { eventId, sectionCode });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/controller/client-inventory-availability-controller.ts